import React, { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { connect } from 'react-redux'
import { loginWithGoogleToken } from '@actions/user'
import { safeRedirectTo } from '@shared/v2Redirect'

function GoogleCallback({ loginWithGoogleToken }) {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const token = searchParams.get('token')
    const userB64 = searchParams.get('user')
    const isPopup = !!window.opener
    
    if (!token || !userB64) {
      if (isPopup) {
        console.error('GoogleCallback: dados inválidos')
        // Tenta postMessage
        try {
          window.opener.postMessage({ type: 'GOOGLE_AUTH_ERROR', message: 'Dados inválidos' }, window.location.origin)
        } catch (e) {
          console.warn('postMessage falhou:', e)
        }
        
        // Salva erro no localStorage
        const authId = localStorage.getItem('google_auth_pending_id')
        if (authId) {
          const storageKey = `google_auth_result_${authId}`
          localStorage.setItem(storageKey, JSON.stringify({
            success: false,
            error: 'Dados inválidos'
          }))
        }
        
        setTimeout(() => window.close(), 100)
      } else {
        navigate('/?google_error=true')
      }
      return
    }

    try {
      const user = JSON.parse(atob(userB64))

      if (isPopup) {
        console.log('GoogleCallback: modo popup detectado')
        
        // Pega o authId do localStorage (janela principal deixou lá)
        const authId = localStorage.getItem('google_auth_pending_id')
        console.log('GoogleCallback: authId encontrado:', authId)
        
        if (authId) {
          // Salva resultado no localStorage usando a chave específica
          const storageKey = `google_auth_result_${authId}`
          const result = {
            success: true,
            token,
            user
          }
          
          console.log('GoogleCallback: salvando resultado no localStorage com chave:', storageKey)
          localStorage.setItem(storageKey, JSON.stringify(result))
        } else {
          console.warn('GoogleCallback: authId não encontrado no localStorage')
        }
        
        // Tenta postMessage também (funciona se não houver COOP)
        try {
          window.opener.postMessage({ type: 'GOOGLE_AUTH_SUCCESS', token, user }, window.location.origin)
          console.log('GoogleCallback: postMessage enviado')
        } catch (e) {
          console.warn('GoogleCallback: postMessage falhou (esperado com COOP):', e)
        }

        // Fecha o popup
        setTimeout(() => {
          console.log('GoogleCallback: fechando popup')
          window.close()
        }, 100)
        return
      }

      // Modo redirect (fallback - quando popup não abre)
      console.log('GoogleCallback: modo redirect, fazendo login direto')
      loginWithGoogleToken(token, user).then(() => {
        // gravado pelo login V2 (googlePopup) em sessionStorage — o boot sem sessão
        // limpa o localStorage (REHYDRATE → destroy) — e validado de novo na leitura
        const returnTo = safeRedirectTo(sessionStorage.getItem('google_return_to'))
        sessionStorage.removeItem('google_return_to')
        if (returnTo) {
          navigate(returnTo)
          return
        }
        const roleId = user.roles && user.roles[0] ? user.roles[0].id : 1
        navigate(roleId >= 2 ? '/admin' : '/')
      })
    } catch (e) {
      console.error('Erro ao processar callback Google:', e)
      if (isPopup) {
        // Tenta postMessage
        try {
          window.opener.postMessage({ type: 'GOOGLE_AUTH_ERROR', message: e.message }, window.location.origin)
        } catch (err) {
          console.warn('postMessage falhou:', err)
        }
        
        // Salva erro no localStorage
        const authId = localStorage.getItem('google_auth_pending_id')
        if (authId) {
          const storageKey = `google_auth_result_${authId}`
          localStorage.setItem(storageKey, JSON.stringify({
            success: false,
            error: e.message
          }))
        }
        
        setTimeout(() => window.close(), 100)
      } else {
        navigate('/?google_error=true')
      }
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh', fontFamily: 'sans-serif' }}>
      <svg width="48" height="48" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{ marginBottom: 16 }}>
        <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
        <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
        <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05"/>
        <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
      </svg>
      <p style={{ color: '#444', fontSize: '1rem' }}>Autenticando com Google...</p>
    </div>
  )
}

const mapDispatchToProps = dispatch => ({
  loginWithGoogleToken: (token, user) => dispatch(loginWithGoogleToken(token, user)),
})

export default connect(null, mapDispatchToProps)(GoogleCallback)
